import IconButton from '@mui/material/IconButton';
import { useDispatch } from 'react-redux';
import ABSSvgIcon from '@abs/core/ABSSvgIcon';
import { toggleQuickPanel } from './store/stateSlice';
import { useTranslation } from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';

function QuickPanelToggleButton(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation('abslayouts');

  return (
    <Tooltip title={t('QUICKPANEL_TOOLTIP')} placement="bottom">
      <IconButton className="w-40 h-40" onClick={(ev) => dispatch(toggleQuickPanel())} size="large">
        {props.children}
      </IconButton>
    </Tooltip>
  );
}

QuickPanelToggleButton.defaultProps = {
  children: <ABSSvgIcon>heroicons-outline:newspaper</ABSSvgIcon>,
};

export default QuickPanelToggleButton;
